module.exports = __webpack_public_path__ + "img/theater.5a4ff4cb.svg";